/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // swap the "," for a "."
    total = total.replace(".", "%").replace(",", ".").replace("%", ",");


    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


/**************
 Dynamic Dialogs
 *************/

// close event
document.querySelectorAll(".dialogPopup")?.forEach(function (element) {
    element.addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });
});

// open gallery event listener
document.querySelectorAll(".openDialog")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).showModal();
        document.querySelector("body").classList.add("noScroll");
    });
});

//close gallery event listener
document.querySelectorAll(".closeDialog")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();
    });
});

document.querySelectorAll(".dialogPopup")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})

// register dialog
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.dialogPopup")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});


/**************
 Product/Collection-item
 *************/

// listen for select menu change
document.querySelectorAll('.collectionItemBodyButtons select')?.forEach(function (element) {
    element.addEventListener('change', function () {
        updateProduct(element);
    });
});

// update product on page load to check availability
document.querySelectorAll('.collectionItemBodyButtons')?.forEach(function (element) {
    updateProduct(element);
});

// find active variant
function getActiveVariant(item, product) {
    // collect options from inputs
    let options = [];
    item.querySelectorAll(`.collectionItemBodyButtonsSelect`)?.forEach(group => {
        options.push(group.value);
    });

    // find new variant based on the options
    let activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // default only fallback
    if (item.dataset.default === "true") {
        activeVariant = product.variants[0];
        return activeVariant;
    }

    return activeVariant;
}


// update product
function updateProduct(element) {
    let collectionItem = element.closest('.collectionItem');
    let product = productIDtoProduct[collectionItem.dataset.id];
    let quantity = collectionItem.querySelector('.collectionItemBodyButtonsQty option:checked').value;

    let activeVariant = getActiveVariant(collectionItem, product);

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        collectionItem.querySelector(".collectionItemBodyBtn").disabled = true;
        collectionItem.querySelector(".collectionItemBodyBtn").textContent = "ausverkauft";
        return;
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        collectionItem.querySelector(".collectionItemBodyBtn").disabled = false;
        collectionItem.querySelector(".collectionItemBodyBtn").textContent = "In den Warenkorb";
    } else {
        collectionItem.querySelector(".collectionItemBodyBtn").disabled = true;
        collectionItem.querySelector(".collectionItemBodyBtn").textContent = "ausverkauft";
    }

    // update price inside of quantity selector∂ç
    collectionItem.querySelectorAll('.collectionItemBodyButtonsQty option')?.forEach(function (option) {
        let qty = parseInt(option.value);
        option.innerHTML = `${qty} - ${price(activeVariant.price * qty)}`;
    });

    // // update price
    collectionItem.querySelector('.collectionItemBodyPrice').textContent = price(activeVariant.price * quantity);


    // update compare at price
    collectionItem.querySelector('.comparePriceVal').textContent = "";
    if (activeVariant.compare_at_price > activeVariant.price) {
        collectionItem.querySelector('.comparePriceVal').textContent = price(activeVariant.compare_at_price * quantity);
    }

    // update save amount
    collectionItem.querySelector('.collectionItemBodyHeaderSale').classList.remove('active')
    if (activeVariant.compare_at_price > activeVariant.price) {
        collectionItem.querySelector('.collectionItemBodyHeaderSale').classList.add('active')
        collectionItem.querySelector('.collectionItemBodyHeaderSaleSave').textContent = price((activeVariant.compare_at_price - activeVariant.price));
    }
}

// Add to cart
document.querySelectorAll('.collectionItemBodyBtn')?.forEach(function (element) {
    element.addEventListener('click', async function () {

        let collectionItem = element.closest('.collectionItem');
        let product = productIDtoProduct[collectionItem.dataset.id];
        let activeVariant = getActiveVariant(collectionItem, product);

        // add loading
        this.classList.add('loading');

        // add product to cart
        let formData = {
            quantity: element.closest('.collectionItem').querySelector('.collectionItemBodyButtonsQty option:checked').value,
            id: activeVariant.id
        }
        await addProduct(formData);

        // remove loading
        this.classList.remove('loading');

        // fill out product info in question popup
        let question = document.querySelector(`#question-${collectionItem.dataset.id}`);

        question.querySelector('.questionBodyInfoPrice').textContent = price(activeVariant.price * element.closest('.collectionItem').querySelector('.collectionItemBodyButtonsQty option:checked').value);
        question.querySelector('.questionBodyInfoVariant').textContent = '';
        if (activeVariant.option1 !== 'Default Title') {
            question.querySelector('.questionBodyInfoVariant').textContent = activeVariant.option1;
        }

        // open question popup
        document.querySelector(`#question-${collectionItem.dataset.id}`).showModal();
        document.querySelector("body").classList.add("noScroll");
    });
});

/**************
 Details Dialog
 *************/


// close event
document.querySelectorAll(".details")?.forEach(function (element) {
    element.addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
        // close all videos
        document.querySelectorAll('.detailsContentAboutVideo')?.forEach(function (element) {
            element.querySelector('.detailsContentAboutVideoPlay')?.classList.remove('active');
            element.querySelector('.detailsContentAboutVideoVid')?.pause();
        });
    });
});

// open details event listener
document.querySelectorAll(".openDetails")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).showModal();
        document.querySelector("body").classList.add("noScroll");
    });
});

//close details event listener
document.querySelectorAll(".closeDetails")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();
    });
});

document.querySelectorAll(".details")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})


// play/pause video
document.querySelectorAll('.detailsContentAboutVideo')?.forEach(function (element) {
    element.addEventListener('click', function () {
        // toggle play button
        this.querySelector('.detailsContentAboutVideoPlay').classList.toggle('active');

        // if video is playing, pause it
        if (this.querySelector('.detailsContentAboutVideoVid').paused) {
            this.querySelector('.detailsContentAboutVideoVid').play();
        } else {
            this.querySelector('.detailsContentAboutVideoVid').pause();
        }
    });
});

// register dialog
document.querySelectorAll(".details")?.forEach(function (element) {
    dialogPolyfill.registerDialog(element);
});


/**************
 Reviews Dialog
 *************/

// close event
document.querySelectorAll(".reviews")?.forEach(function (element) {
    element.addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });
});

// open reviews event listener
document.querySelectorAll(".openReviews")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).showModal();
        document.querySelector("body").classList.add("noScroll");
    });
});

//close reviews event listener
document.querySelectorAll(".closeReviews")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();
    });
});

document.querySelectorAll(".reviews")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})

// register dialog
document.querySelectorAll(".reviews")?.forEach(function (element) {
    dialogPolyfill.registerDialog(element);
});

/**************
 Question Dialogs
 *************/

// close event
document.querySelectorAll(".question")?.forEach(function (element) {
    element.addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });
});


//close gallery event listener
document.querySelectorAll(".closeQuestion")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();
    });
});

document.querySelectorAll(".question")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})

// register dialog
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.question")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});
